// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import Vue from 'vue'
//import App from './App'
import router from './router'
import Vue from 'vue'
import FastClick from 'fastclick'
//import VueRouter from 'vue-router'
import App from './App'
/*import Home from './components/Home'
import MemberCenter from './components/MemberCenter.vue'
import PaymentCenter from './components/PaymentCenter.vue'
import PaymentDetail from './components/PaymentDetail.vue'
import Fix from './components/Fix.vue'
import FixMy from './components/FixMy.vue'
import Complain from './components/Complain.vue'
import ComplainMy from './components/ComplainMy.vue'
import LetPass from './components/LetPass.vue'
import LetPassMy from './components/LetPassMy.vue'
import HelpCenter from './components/HelpCenter.vue'
import HelpDetail from './components/HelpDetail.vue'
import Login from './components/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/MemberCenter',
    component: MemberCenter
  },
  {
    path: '/PaymentCenter',
    component: PaymentCenter
  },
  {
    path: '/PaymentDetail',
    component: PaymentDetail
  },
  {
    path: '/Fix',
    component: Fix
  },
  {
    path: '/FixMy',
    component: FixMy
  },
  {
    path: '/Complain',
    component: Complain
  },
  {
    path: '/ComplainMy',
    component: ComplainMy
  },
  {
    path: '/LetPass',
    component: LetPass
  },
  {
    path: '/LetPassMy',
    component: LetPassMy
  },
  {
    path: '/HelpCenter',
    component: HelpCenter
  },
  {
    path: '/HelpDetail',
    component: HelpDetail
  },
  {
    path: '/Login',
    component: Login
  }
]

const router = new VueRouter({
  routes
})*、

//Vue.config.productionTip = false

/* eslint-disable no-new */
/*new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

Vue.component('header-item', {
  props: ['message', 'backUrl'],
  template: `<header class="evaluate-header"><router-link :to="backUrl"><span><i class="iconfont">&#xe697;</i></span></router-link> <div><span>{{message}}</span></div> </header>`
})*/
FastClick.attach(document.body)

/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js